import { Component, TemplateRef } from '@angular/core';
import { ToastService } from 'services/toast.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, NgClass } from '@angular/common';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [NgbToastModule, CommonModule, NgClass],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  host: {
    class: 'toast-container position-fixed top-0 end-0 p-3',
    style: 'z-index: 1200'
  }
})
export class ToastContainerComponent {
  constructor(public toastService: ToastService) {}

  isTemplate(toast: any) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
